import { coreAxios } from "@/declare/api/axios"
import { AxiosResponse } from "axios"

/**
 * 添加项目参与人
 * @returns
 */
export function addProjectUser(projectUuid: string, userUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/projects/${projectUuid}/users/${userUuid}`, null, {
        params: {
            ...params,
        }
    })
}

/**
 * 获取项目参与人列表
 * @returns
 */
export function findProjectUsers(projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectUuid}/users`, {
        params: {
            ...params,
        }
    })
}

/**
 * 删除项目参与人
 * @returns
 */
export function deleteProject(projectUuid: string, userUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.delete(`/projects/${projectUuid}/users/${userUuid}`, {
        params: {
            ...params,
        }
    })
}

/**
 * 删除项目所有参与人
 * @returns
 */
export function deleteProjectAllUsers(projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.delete(`/projects/${projectUuid}/users`, {
        params: {
            ...params,
        }
    })
}

/**
 * 批量添加项目参与人
 * @param projectUuid 项目UUID
 * @param userUuids 用户UUID列表
 * @returns Promise
 */
export function addProjectUsersBatch(projectUuid: string, userUuids: string[]): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/projects/${projectUuid}/users/batch`, userUuids);
}

/**
 * 批量删除项目参与人
 * @param projectUuid 项目UUID
 * @param userUuids 用户UUID列表
 * @returns Promise
 */
export function deleteProjectUsersBatch(projectUuid: string, userUuids: string[]): Promise<AxiosResponse<any>> {
    return coreAxios.delete(`/projects/${projectUuid}/users/batch`, {
        data: userUuids, // DELETE 方法传递请求体时需要使用 `data`
    });
}